import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js';
import { SubscriptionForm } from './SubscriptionForm';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY!);

const stripeOptions: StripeElementsOptions = {
  mode: 'subscription',
  amount: 500,
  currency: 'gbp',
  paymentMethodCreation: 'manual'
};

export const SubscriptionPayment = () => {
  return (
    <Elements
      options={stripeOptions}
      stripe={stripePromise}
    >
      <div className='grow flex flex-col justify-between'>
        <h2 className='text-center text-xl my-4'>Subscribe to JustWords Premium for £5/month</h2>
        <SubscriptionForm />
      </div>
    </Elements>
  );
};
